export const hubsMultiSelectIntlIds = {
  allValuesLabel: 'hubsMultiSelectIntlIds.allValuesLabel',
  placeholder: 'hubsMultiSelectIntlIds.placeholder',
  noOptionsLabel: 'hubsMultiSelectIntlIds.noOptionsLabel',
};
